import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Orgimage } from '@src/app/components/orglogo/model/orgimage';
import { OrglogoService } from '@src/app/components/orglogo/service/orglogo.service';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Orgstyle } from '@src/app/helpers/uieventhub/model/orgstyle';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { Subscription } from 'rxjs';
import { PersonOrganization } from '../../model/personorganization';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-orglogomenu',
  templateUrl: './orglogomenu.component.html',
  styleUrls: ['./orglogomenu.component.css']
})
export class OrglogomenuComponent implements OnInit,OnChanges {

  @Input() useraccount:boolean;
  @Input() showFileDialog:boolean;
  selectedFiles: FileList;
  selectedFileName: string;
  @Input() sidebarlogo:boolean;
  @Input() orgimage:Orgimage;
  @Input() orgId:string;
  @Input() modalchanger:boolean;

  @Input() whitelabeled:boolean;
  //type can be rect or square
  @Input() imgtype:string;
  refreshBlock:boolean;

  dynStyleSubscription:Subscription;
  orgstyle:Orgstyle;
  chosenOrg:PersonOrganization;


    constructor(
      private orgImageService:OrglogoService, 
      private uievent:UieventhubService
     ) { 
      this.dynStyleSubscription = this.uievent.dynamicStyle$.pipe(untilDestroyed(this)).subscribe(style => {
        this.orgstyle = style;
        if(this.orgstyle.logoformat == 'square' || this.orgstyle.logoformat == 'squareandtitle') this.imgtype = 'square';
        if(this.orgstyle.logoformat == 'rectangel' || !this.orgstyle) this.imgtype = 'rect';
        this.refreshUrl();
      });
    }
    ngOnChanges(changes: SimpleChanges) {
      if(changes.orgId && changes.orgId.currentValue){
        this.orgId = changes.orgId.currentValue;
      }
      if(changes.imgtype && changes.imgtype.currentValue){
        this.imgtype = changes.imgtype.currentValue;
        //console.log('Img type changed to',this.imgtype);
        if(sessionStorage.getItem('currentOrgLogoUrl-'+this.orgId+'_'+this.imgtype)){
          this.orgimage = new Orgimage;
          this.orgimage.type = this.imgtype;
          this.orgimage.orgimageurl = sessionStorage.getItem('currentOrgLogoUrl-'+this.orgId+'_'+this.imgtype);
        }else{
          this.refreshUrl();
        }
      }
    }
  

    
  
    ngOnInit() {
      this.orgimage = new Orgimage;
      this.orgimage.type = this.imgtype;
      if(sessionStorage.getItem('currentOrgLogoUrl-'+this.orgId+'_'+this.imgtype)){
        this.orgimage.orgimageurl = sessionStorage.getItem('currentOrgLogoUrl-'+this.orgId+'_'+this.imgtype);
      }else{
        this.refreshUrl();
      }
        
    }

    refreshUrl(){
      if(!this.refreshBlock){
        this.refreshBlock = true;
        //console.log('refresh logo url reached')
        //console.log('refresh logo get image '+this.orgId+'_'+this.imgtype, sessionStorage.getItem('currentOrgLogoUrl-'+this.orgId+'_'+this.imgtype));
        this.orgImageService.getorgImageDB(this.orgId,this.imgtype).pipe(untilDestroyed(this)).subscribe(pi => {
          if(pi != "No image for this organization."){
            this.orgimage = pi;
              sessionStorage.setItem('currentOrgLogoUrl-'+this.orgId+'_'+this.orgimage.type , this.orgimage.orgimageurl) ;
              this.refreshBlock = false;
          }
        });
      }
      
    }


}
